<bootstrap-popup
	[id]="id"
	[title]="'D&eacute;tail Acc&egrave;s'"
	[windowCloseButton]="true"
	[displaySubject]="displaySubject"
	>
	<ng-container *ngIf="loaded">
		<div class="panel panel-default">
			<div class="panel-heading"><h3>Autorisation d'acc&egrave;s</h3></div>
			<div class="panel-body">
				<div class="row">
					<div class="col-md-6 col-sm-6" *ngIf="user.role != 'INT' || acces.etat >= 1">
						<label class="control-label" for="accesEntreprise">Num&eacute;ro :&nbsp;</label>{{ acces.numero }}
					</div>
					<div class="col-md-6 col-sm-6">
						<label class="control-label" for="accesNumero">Etat :&nbsp;</label>{{ libellesEtats[acces.etat] }}
					</div>
				</div>
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<label class="control-label">Cr&eacute;&eacute; par :&nbsp;</label><span>{{ initiateur }} le {{ acces.dateCreation | localDateTimeToDate: acces.ice | date: 'dd/MM/yyyy à HH:mm' }}</span>
					</div>
					<div class="col-md-6 col-sm-6" *ngIf="acces.etat >= 1 && acces.etat <= 4">
						<label class="control-label" for="accesNumero">{{ acces.etat == 1 || acces.etat == 2 || acces.etat == 3 ? 'Accord&eacute;' : 'Refus&eacute;'}} par : </label>
						<span>
							{{ acces.etat === 2 || acces.etat === 3 ? valideur : cac }} {{ acces.dateAutorisation ? (acces.dateAutorisation | localDateTimeToDate: acces.ice | date: ' le dd/MM/yyyy à HH:mm') : '' }}
							{{ acces.etat === 4  && acces.dateFermeture ? (acces.dateFermeture | localDateTimeToDate: acces.ice | date: ' le dd/MM/yyyy à HH:mm') : '' }}
						</span>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6 col-sm-6" *ngIf="acces.etat === 3">
						<label class="control-label" for="accesNumero">Ferm&eacute; par :&nbsp;</label>{{ cacFermeture }}{{ acces.dateFermeture ? (acces.dateFermeture | localDateTimeToDate: acces.ice | date: ' le dd/MM/yyyy à HH:mm') : '' }}
					</div>
					<div class="col-md-6 col-sm-6" *ngIf="acces.etat === 4">
						<label class="control-label" for="accesNumero">Motif Refus : </label>
						{{ motifRefus }}
					</div>
				</div>
				<div class="row">
					<div class="col-md-3 col-sm-3">
						<label class="control-label" for="accesCegex">Type d'acc&egrave;s : </label>
						{{ acces.accesCegex ? 'CEGEX' : 'Hors CEGEX' }}
					</div>
					<div class="col-md-3 col-sm-3">
						<label class="control-label" for="accesType">Type : </label>
						{{ libellesTypesAcces[acces.typeAcces] }}
					</div>
					<div class="col-md-6 col-sm-6">
						<label class="control-label" for="accesDebut">Date de d&eacute;but : </label>
						{{ acces.dateDebut | localDateTimeToDate: acces.ice | date : 'dd/MM/yyyy à HH:mm' }}
					</div>
				</div>
			</div>
		</div>
	
		<div class="panel panel-default">
			<div class="panel-heading"><h4>Intervenants</h4></div>
			<div class="panel-body">
				<div class="panel-body tablecontainer tablo-inter">
					<table class="table table-striped">
						<thead>
							<tr>
								<th>R&ocirc;le</th>
								<th>Entreprise</th>
								<th>Intervenant</th>
								<th><i class="fa fa-phone-square"></i> &nbsp; <i class="fa fa-envelope"></i></th>
								<th>Habilitations</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let participant of participants">
								<td>
									{{ participant.roleLabel }}
								</td>
								<td>
									{{ participant.nomEntreprise }}
								</td>
								<td>
									{{ participant.nomIntervenant }}
								</td>
								<td>
									{{ participant.intervenant?.indicatifTelephone }} {{participant.intervenant?.telephone }} {{ participant.intervenant?.email }}
								</td>
								<td>			
									<intervenant-status *ngIf="participant.intervenant as intervenant" [idIntervenant]="intervenant.id" [idOuvrages]="ouvragesIds" 
										[spacing]="'5px'" [idParc]="parc.id" [pdpIconsToShow]="participant.displayablePdpTypes"></intervenant-status>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	
		<div class="panel panel-default">
			<div class="panel-heading"><h4>P&eacute;rim&egrave;tre</h4></div>
			<div class="panel-body">	
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<label class="control-label" for="accesParc">Parc&nbsp;:&nbsp;</label>
							<span>{{ parc.code }}&nbsp;</span>
							<span *ngIf="parc.type || parc.energie">( </span>
							<span *ngIf="parc.type">Type: {{ parc.type }}</span>
		                  	<span *ngIf="parc.type && parc.energie"> - </span>
		                  	<span *ngIf="parc.energie">Technologie: <i class="fa {{ energyIcon }}" title="{{ parc.energie }}"></i></span>
		                  	<span *ngIf="parc.type || parc.energie"> )</span>
	                </div>
				</div>
				
				<div class="row">
					<div class="col-md-6 col-sm-6" *ngIf="responsableParc">
						<label class="control-label" for="respExploitation">R&eacute;f. de parc&nbsp;:&nbsp;</label>
		                  	<span>{{ responsableParc.prenom }} {{ responsableParc.nom }}</span>
		                  	<span *ngIf="responsableParc && responsableParc?.telephone">
		                  		&nbsp;&nbsp;
	                            <i class="fa fa-phone-square"></i>
		                  		{{ responsableParc.indicatifTelephone }} {{ responsableParc.telephone }}
		                  	</span>
		                  	<span *ngIf="responsableParc && responsableParc?.email">
		                  		&nbsp;&nbsp;
		                  		<i class="fa fa-envelope"></i>
		                  		{{ responsableParc.email }}
		                  	</span>
	                </div>
	                
					<div class="col-md-6 col-sm-6 indicateurs-row">
			    		<label class="control-label">M&eacute;t&eacute;o :</label>
			    		<span class="indicateurs-list">
			    			<span class="popover__wrapper" *ngFor="let indicateur of indicateurs">
			    				<i class="fa-2x {{ indicateur.icon }}" [style.color]="indicateur.couleur" ></i>
			    				<div class="popover__content">
			    					<div class="panel panel-default modal-sm">
			    						<div class="panel-heading" role="document">
			    							<h3>{{ indicateur.nom }}</h3>
			    						</div>
			    						<div class="panel-body">
			    							<strong>Niveau&nbsp;:</strong><br/>
			    							<span>{{ indicateur.niveau }}</span><br/>
			    							<br/>
			    							<ng-container *ngIf="indicateur.regle">
			    								<strong>R&egrave;gle applicable&nbsp;:</strong><br/>
			    								<span class="regle">{{ indicateur.regle }}</span>
			    							</ng-container>
			    							<strong *ngIf="!indicateur.regle">Aucune r&egrave;gle connue.</strong><br/>
											<br/>
											<ng-container *ngIf="indicateur.dateModification">
											<strong>Date de dernière modification&nbsp;:</strong><br/>
											<span class="regle">{{ indicateur.dateModification | localDateTimeToDate: true | date : 'dd/MM/yyyy à HH:mm' }}</span>
											</ng-container>
			    						</div>
			    					</div>
			    				</div>
			    			</span>
			    		</span>
					</div>
				</div>
				
				<div class="row spacing-top">
			  		<div class="col-md-6 col-sm-6">
			    		<label class="control-label" for="antenneAstreintes">Tel astreinte&nbsp;:</label>
			    		{{ antenne.telephoneAstreintes ? antenne.telephoneAstreintes.join(', ') : '' }}
			  		</div>
			
			  		<div class="col-md-6 col-sm-6">
			    		<label class="control-label" for="memoParc">Mémo parc&nbsp;:&nbsp;</label>
			    		<ul class="memo-list">
			      			<li class="popover__wrapper" *ngFor="let memo of displayedMemosParc; let i = index">
			        			<div [ngClass]="memo.entity.niveauId == 1 ? 'text-primary' : 'text-danger'">
			          				{{ memo.categorie }} {{ memo.entity.intitule }}
			          				<span *ngIf="memo.entity.dateDebut && !memo.entity.dateFin">
			            				(le {{ memo.entity.dateDebut | displayLocalDate }})
			          				</span>
			          				<span *ngIf="memo.entity.dateDebut && memo.entity.dateFin">
			            				(du {{ memo.entity.dateDebut | displayLocalDate }} au {{ memo.entity.dateFin | displayLocalDate }})
			          				</span>
			        			</div>
			
			        			<div class="popover__content">
			          				<div class="panel panel-default">
			            				<div class="panel-heading" role="document">
			              					<h3>Commentaire</h3>
			            				</div>
			            				<div class="panel-body">
			              					<p>{{ memo.entity.commentaire }}</p>
			            				</div>
			          				</div>
			        			</div>
			      			</li>
			    		</ul>
			  		</div>
				</div>

				<div class="row spacing-top">
				  <div class="col-md-6 col-sm-6">
				    <label class="control-label" for="accesOuvrages">Liste des ouvrages&nbsp;:</label>
				    {{ ouvragesLabel }}
				  </div>
				
				  <div class="col-md-6 col-sm-6">
				    <label class="control-label" for="memoOuvrage">Mémo ouvrage&nbsp;:&nbsp;</label>
				    <ul class="memo-list">
				      <li class="popover__wrapper intitule" *ngFor="let memo of memoOuvrage; let i = index">
				        <span [ngClass]="memo.niveauId == 1 ? 'text-primary' : 'text-danger'">
				          {{ memo.intitule }}
				          <span *ngIf="memo.dateDebut && !memo.dateFin">
			            	(le {{ memo.dateDebut | displayLocalDate }})
			          	</span>
          				<span *ngIf="memo.dateDebut && memo.dateFin">
            				(du {{ memo.dateDebut | displayLocalDate }} au {{ memo.dateFin | displayLocalDate }})
          				</span>
				        </span>
				        <div class="popover__content">
				          <div class="panel panel-default">
				            <div class="panel-heading" role="document">
				              <h3>Commentaire</h3>
				            </div>
				            <div class="panel-body">
				              <p>{{ memo.commentaire }}</p>
				            </div>
				          </div>
				        </div>
				        <span *ngIf="i < memoOuvrage.length - 1">, </span>
				      </li>
			    	</ul>
				  </div>
				</div>
				
				<div class="row spacing-top">
				  <div class="col-md-6 col-sm-6">
				    <label class="control-label" for="accesOuvrages">Ouvrages concern&eacute;s&nbsp;:</label>
				    {{ ouvragesConcernes }}
				  </div>
				
				  <div class="col-md-6 col-sm-6">
				    <label class="control-label" for="memoOuvrage">Mémo ouvrage concern&eacute;s&nbsp;:</label>
				    <ul class="memo-list">
				      <li class="popover__wrapper intitule" *ngFor="let memo of memoOuvrageConcernes; let i = index">
				        <span [ngClass]="memo.niveauId == 1 ? 'text-primary' : 'text-danger'">
				          {{ memo.intitule }}
				          <span *ngIf="memo.dateDebut && !memo.dateFin">
			            	(le {{ memo.dateDebut | displayLocalDate }})
			          	</span>
          				<span *ngIf="memo.dateDebut && memo.dateFin">
            				(du {{ memo.dateDebut | displayLocalDate }} au {{ memo.dateFin | displayLocalDate }})
          				</span>
				        </span>
				        <div class="popover__content">
				          <div class="panel panel-default">
				            <div class="panel-heading" role="document">
				              <h3>Commentaire</h3>
				            </div>
				            <div class="panel-body">
				              <p>{{ memo.commentaire }}</p>
				            </div>
				          </div>
				        </div>
				        <span *ngIf="i < memoOuvrage.length - 1">, </span>
				      </li>
			    	</ul>
				  </div>
				</div>

				<div class="row spacing-top">
					<div class="col-md-6 col-sm-6">
						<label class="control-label" for="accesType">P&eacute;rim&egrave;tre : </label>
						{{acces.portee}}
					</div>
					<div class="col-md-6 col-sm-6">
						<label class="control-label" for="accesType">Astreinte : </label>
						{{acces.astreinte ? 'Oui' : 'Non'}}
					</div>
				</div>
				
				<div class="row spacing-top">
					<div class="col-md-12" *ngIf="acces.etat == 3">
						<label class="control-label" for="etatsOuvrages">Etat des ouvrages : </label>
						{{ etatsOuvrages }}
					</div>
				</div>
			</div>
		</div>
		
		<div class="panel panel-default">
			<div class="panel-heading"><h4>Commentaires</h4></div>
			<div class="panel-body">	
				<div class="row">
					<div class="col-md-12">
						<label class="control-label" for="accesCommentaire">Lors de la cr&eacute;ation ou autorisation
							: </label>
						<p class="commentaire">{{ acces.commentaire }}</p>
					</div>
					</div>
				<div class="row">
					<div class="col-md-12" *ngIf="acces.etat == 3">
						<label class="control-label" for="accesCommentaireFermeture">Lors de la fermeture ou refus
							: </label>
						<p class="commentaire">{{ acces.commentaireFermeture }}</p>
					</div>
				</div>
	
			</div>
		</div>
	
		<div class="panel panel-default" *ngIf="operations.length || demandeInterventions.length">
			<div class="panel-heading clickable" *ngIf="operations.length || demandeInterventions.length"
				(click)="interAssocieesChapoDisplay = !interAssocieesChapoDisplay">
				<span>
					<h4>
						<i [class]="interAssocieesChapoDisplay ? 'fa-regular fa-square-minus' : 'fa-regular fa-square-plus'"></i>
						Op&eacute;rations et demandes d'intervention associ&eacute;es
					</h4>
				</span>
			</div>
			<div class="panel-body" *ngIf="interAssocieesChapoDisplay">
				<div *ngIf="operations.length">
					<div class="panel panel-default" *ngFor="let operation of operations; let index = index;">
						<div class="panel-heading clickable" (click)="operationsAssocieeDisplay[index] = !operationsAssocieeDisplay[index]">
							<span>
								<h4>
									<i [class]="operationsAssocieeDisplay[index] ? 'fa-regular fa-square-minus' : 'fa-regular fa-square-plus'"></i>
									Op&eacute;ration {{ operation.label }}
								</h4>
							</span>
						</div>
						<div class="panel-body" *ngIf="operationsAssocieeDisplay[index]" >
							<div class="row">
								<div class="col-md-6 col-sm-6" >
									<label class="control-label" for="accesInterventions">Acte&nbsp;:&nbsp;</label>
									<span>{{ operation.acte }}</span>
								</div>
								<div class="col-md-6 col-sm-6" >
									<label class="control-label" for="accesInterventions">Etat&nbsp;:&nbsp;</label>
									<span>{{ operation.etat }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="accesInterventions">Date de d&eacute;but&nbsp;:&nbsp;</label>
									<span> {{ operation.entity.dateDebut | displayLocalDate }}</span>
								</div>
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="accesInterventions">Date de fin&nbsp;:&nbsp;</label>
									<span>{{ operation.entity.dateFin | displayLocalDate }}</span>
								</div>
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="">Ouvrage&nbsp;:&nbsp;</label>
									<span>{{ operation.ouvrage }}</span>
								</div>
								<div class="col-md-6 col-sm-6" *ngIf="operation.entity.codeCarl">
									<label class="control-label" for="">N&deg; CR CARL&nbsp;:&nbsp;</label>
									<span>{{ operation.entity.codeCarl }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div *ngIf="demandeInterventions.length">
					<div class="panel panel-default" *ngFor="let di of demandeInterventions; let index = index;">
						<div class="panel-heading clickable" (click)="disAssocieeDisplay[index] = !disAssocieeDisplay[index]">
							<span>
								<h4>
									<i [class]="disAssocieeDisplay[index] ? 'fa-regular fa-square-minus' : 'fa-regular fa-square-plus'"></i>
									Demande d'intervention {{ di.refDemandeInterventionCarl }} : {{ di.refOuvrageDansCarl }} : {{ di.intitule }}
								</h4>
							</span>
						</div>
						<div class="panel-body" *ngIf="disAssocieeDisplay[index]" >
							<div class="row">
								<div class="col-md-12 col-sm-12">
									<label class="control-label" for="">DI&nbsp;:&nbsp;</label>
									<span>{{ di.intitule }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="">Ouvrage&nbsp;:&nbsp;</label>
									<span>{{ di.refOuvrageDansCarl }}</span>
								</div>
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="">N&deg; DI&nbsp;:&nbsp;</label>
									<span>{{ di.refDemandeInterventionCarl }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  -->
		<div class="panel panel-default" *ngIf="workorders.length || notifications.length">
			<div class="panel-heading clickable" *ngIf="workorders.length || notifications.length" (click)="woAssocieesChapoDisplay = !woAssocieesChapoDisplay">
				<span>
					<h4>
						<i [class]="woAssocieesChapoDisplay ? 'fa-regular fa-square-minus' : 'fa-regular fa-square-plus'"></i>
						Workorders et Notifications associées
					</h4>
				</span>
			</div>
			<div class="panel-body" *ngIf="woAssocieesChapoDisplay">
				<div *ngIf="workorders.length">
					<div class="panel panel-default" *ngFor="let wo of workorders; let index = index;">
						<div class="panel-heading clickable" (click)="wosAssocieeDisplay[index] = !wosAssocieeDisplay[index]">
							<span>
								<h4>
									<i [class]="wosAssocieeDisplay[index] ? 'fa-regular fa-square-minus' : 'fa-regular fa-square-plus'"></i>
									Workorder {{ wo.workOrder }} : {{ wo.workOrderDesc }} : {{ wo.status }} : {{ wo.statusText }}
								</h4>
							</span>
						</div>
						<div class="panel-body" *ngIf="wosAssocieeDisplay[index]" >
							<div class="row">
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="">Workorder&nbsp;:&nbsp;</label>
									<span>{{ wo.workOrderDesc }} ({{ wo.status }} : {{ wo.statusText }})</span>
								</div>
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="">Date&nbsp;:&nbsp;</label>
									<span>{{ wo.basicStartDate | localDateTimeToDate: false | date : 'dd/MM/yyyy' }}
									</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="">Ouvrage&nbsp;:&nbsp;</label>
									<span>{{ wo.ouvrageNom }}</span>
								</div>
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="">N&deg;&nbsp;:&nbsp;</label>
									<span>{{ wo.workOrder }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div *ngIf="notifications.length">
					<div class="panel panel-default" *ngFor="let notification of notifications; let index = index;">
						<div class="panel-heading clickable" (click)="notifsAssocieeDisplay[index] = !notifsAssocieeDisplay[index]">
							<span>
								<h4>
									<i [class]="notifsAssocieeDisplay[index] ? 'fa-regular fa-square-minus' : 'fa-regular fa-square-plus'"></i>
									Notification {{ notification.notificationNumber }} : {{ notification.notificationDesc }} : {{ notification.status }} : {{ notification.statusText }}
								</h4>
							</span>
						</div>
						<div class="panel-body" *ngIf="notifsAssocieeDisplay[index]" >
							<div class="row">
								<div class="col-md-12 col-sm-12">
									<label class="control-label" for="">Notification&nbsp;:&nbsp;</label>
									<span>{{ notification.notificationDesc }} ({{ notification.status }} : {{ notification.statusText }})</span>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="">Ouvrage&nbsp;:&nbsp;</label>
									<span>{{ notification.ouvrageNom }}</span>
								</div>
								<div class="col-md-6 col-sm-6">
									<label class="control-label" for="">N&deg;&nbsp;:&nbsp;</label>
									<span>{{ notification.notificationNumber }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  -->
		<div class="panel panel-default" *ngIf="arrets.length">
			<div class="panel-heading clickable" (click)="arretsAssocieesChapoDisplay = !arretsAssocieesChapoDisplay">
				<span>
					<h4>
						<i [class]="arretsAssocieesChapoDisplay ? 'fa-regular fa-square-minus' : 'fa-regular fa-square-plus'"></i>
						Arr&ecirc;ts associ&eacute;s
					</h4>
				</span>
			</div>
			<div class="panel-body" *ngIf="arretsAssocieesChapoDisplay">
				<div class="panel panel-default" *ngIf="acces.commentaireArrets != null && acces.commentaireArrets.length > 0">
					<div class="panel-heading clickable" (click)="commentaireArretDisplay = !commentaireArretDisplay">
						<span>
							<h4>
								<i [class]="commentaireArretDisplay ? 'fa-regular fa-square-minus' : 'fa-regular fa-square-plus'"></i>
								Commentaires
							</h4>
						</span>
					</div>
					<div class="panel-body" *ngIf="commentaireArretDisplay" >
						<p class="commentaire"> {{ acces.commentaireArrets }} </p>
					</div>
				</div>
				<div class="panel panel-default" *ngFor="let arret of arrets; let index = index;">
					<div class="panel-heading clickable" (click)="arretAssocieDisplay[index] = !arretAssocieDisplay[index]">
						<span>
							<h4>
								<i [class]="arretAssocieDisplay[index] ? 'fa-regular fa-square-minus' : 'fa-regular fa-square-plus'"></i>
								Arr&ecirc;t {{ index + 1 }}
							</h4>
						</span>
					</div>
					<div class="panel-body" *ngIf="arretAssocieDisplay[index]" >
						<div class="row">
							<div class="col-md-6 col-sm-6">
								<label class="control-label">Equipement&nbsp;:&nbsp;</label> {{ arret.entityCode }}
							</div>
						</div>	
						<div class="row">
							<div class="col-md-6 col-sm-6">
								<label class="control-label">Date de d&eacute;but&nbsp;:&nbsp;</label>{{ arret.startDate | localDateTimeToDate: false | date: 'dd/MM/yyyy à HH:mm' }}
							</div>
							<div class="col-md-6 col-sm-6">
								<label class="control-label">Date de fin&nbsp;:&nbsp;</label>{{ arret.endDate | localDateTimeToDate: false | date: 'dd/MM/yyyy à HH:mm' }}
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<label class="control-label">Description&nbsp;:&nbsp;</label>
								<p class="commentaire">{{ arret.statusCodeOrigin }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="text-left" *ngIf="canNotify">
			<button type="button" class="btn btn-primary" (click)="notifier()">Notifier</button>
	   	</div>
	</ng-container>
	<ng-container *ngIf="!loaded">
		Chargement...
	</ng-container>
	<div class="col-sm-12 text-center" style="float: none">
		<button type="button" class="btn btn-primary" (click)="close()">Fermer</button>
	</div>	   	
</bootstrap-popup>